
<form [formGroup]="editUserForm" (ngSubmit)="updateUser()" *ngIf="editUserForm.value">
    <div class="modal-header">
        <h4>{{ modalMode }} User</h4>
        <a class="close-icon" href="javascript:void()" ngbAutofocus><i class="flaticon2-cross"
                (click)="closeAddUSerModal()"></i></a>
    </div>
    <div class="modal-body output-lable new-user">
        <div class="row">
            <div class="col-md-12" style="padding: 15px">
                <div class="email-wrapper w-100">
                    <mat-label class="font-style">Email</mat-label>
                    <mat-form-field class="search_field custom-text-field w-100" [floatLabel]="'never'">
                        <input matInput type="email" placeholder="Enter email" formControlName="user_email" readonly />
                    </mat-form-field>
                    <!-- <button type="button" class="validate_button btn primary-ebtn" (click)="validateUser()" [disabled]="editUserForm.get('user_email').hasError('email')">Validate</button> -->
                </div>
                <div class="name-wrapper">
                    <div class="input-names-wrapper">
                        <mat-label class="font-style">First Name</mat-label>
                        <mat-form-field [floatLabel]="'never'" class="custom-text-field">
                            <input matInput type="text" placeholder="Enter first name" formControlName="user_first_name"
                                readonly />
                        </mat-form-field>
                    </div>
                    <div class="input-names-wrapper">
                        <mat-label class="font-style">Last Name</mat-label>
                        <mat-form-field [floatLabel]="'never'" class="custom-text-field">
                            <input matInput type="text" placeholder="Enter last name" formControlName="user_last_name"
                                readonly />
                        </mat-form-field>
                    </div>
                </div>
                <div class="user_role mb-4">
                    <div class="user-role-wrapper" *ngIf="true">
                        <h5 class="user-head">User Type</h5>
                        <div class="user-role-dropdown-wr">
                            <mat-select class="dropdown-wrapper" panelClass="dropdown-wrapper" placeholder="Select Role"
                                [(value)]="selectedOptionUserType" formControlName="user_type"
                                [attr.disabled]="disableOptions === true">
                                <mat-option class="option-list" value="{{ role.securityRoleId }}"
                                    *ngFor="let role of userRoleObject">{{
                                    role.name
                                    }}</mat-option>
                            </mat-select>
                        </div>
                    </div>
                </div>
                <div class="sliders" formGroupName="licenseGroup">
                    <div class="left-toggles">
                        <div class="toggle-wrap mt-4 mb-4">
                            <mat-label class="slide-toggle-label">IDMS License: </mat-label>
                            <mat-slide-toggle formControlName="idms_license"
                                [attr.disabled]="disableOptions === true"></mat-slide-toggle>
                        </div>
                        <div class="toggle-wrap mt-4 mb-4">
                            <mat-label class="slide-toggle-label">ICE License: </mat-label>
                            <mat-slide-toggle formControlName="informate_license"
                                [attr.disabled]="disableOptions === true"></mat-slide-toggle>
                        </div>
                    </div>
                    <div class="right-toggles">
                        <div class="toggle-wrap mt-4 mb-4">
                            <mat-label class="slide-toggle-label">CA License: </mat-label>
                            <mat-slide-toggle formControlName="ca_license"
                                [attr.disabled]="disableOptions === true"></mat-slide-toggle>
                        </div>
                    </div>
                    <span class="error-message" style="grid-column: 1 / -1;"
                            *ngIf="this.editUserForm.get('licenseGroup').hasError('requireOneCheckboxToBeChecked')">At
                            least one license is required</span>
                </div>
                <div class="licenseType-wrapper">
                    <div class="licensetype-sub mt-4 mb-4">
                        <h5 class="license-heading">License Type</h5>
                        <mat-select class="dropdown-wrapper" panelClass="dropdown-wrapper"
                            placeholder="Select License Type" [(value)]="licenseTypeName" formControlName="license_type"
                            [ngClass]="editUserForm.get('license_type').invalid && isAddButtonClicked ? 'custom-error' : ''"
                            [attr.disabled]="disableOptions === true">
                            <mat-option class="option-list" *ngFor="let license of licenseType"
                                value="{{ license.name }}">{{ license.name }}</mat-option>
                        </mat-select>
                    </div>
                </div>
                <div class="row mb-4 mt-4" *ngIf="licenseTypeName === 'Renewal'">
                    <div class="col-6">
                        <mat-label>Start Date</mat-label>
                        <dx-date-box class="dx-date-custom-wrapper" formControlName="license_startDate"
                            displayFormat="dd-MMM-yyyy" [inputAttr]="{ 'aria-label': 'Choose Date' }"
                            [min]="currentDate" blockDateTyping>
                        </dx-date-box>
                        <!-- Added 'blockDateTyping' directive to block typing  in dx-datepicker -->
                    </div>
                    <div class="col-6">
                        <mat-label>End Date</mat-label>
                        <dx-date-box class="dx-date-custom-wrapper" formControlName="license_endDate"
                            displayFormat="dd-MMM-yyyy" [inputAttr]="{ 'aria-label': 'Choose Date' }" [disabled]="true"
                            [min]="currentDate" blockDateTyping>
                        </dx-date-box>
                        <!-- Added 'blockDateTyping' directive to block typing  in dx-datepicker -->
                    </div>
                </div>
                <div class="input-wrapper" *ngIf="licenseTypeName === 'Timed'">
                    <div class="timed-wrapper">
                        <mat-label>No. of Days</mat-label>
                        <mat-form-field [floatLabel]="'never'" class="custom-text-field">
                            <input type="number" matInput placeholder="Enter Number Of Days"
                                (keypress)="numberOnly($event)" formControlName="license_days" autocomplete="off"
                                [readonly]="disableOptions === true" />
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn secondary-ebtn" (click)="closeAddUSerModal()">Cancel</button>
        <button type="submit" *ngIf="disableOptions === false" class="btn primary-ebtn"
            [disabled]="!(editUserForm.valid && editUserForm.dirty)">Update</button>

    </div>
</form>